module.exports = __webpack_public_path__ + "img/service_visitor.9b2283b9.jpg";